export const INSURANCE = {
  DUE_PAYMENT: 'insurance_missing_occurrence',
  DUE_PAYMENT_RESULT: 'insurance_missing_occurrence_payment_result',
  DUE_PAYMENT_COMPLETED: 'insurance_missing_occurrence_completed',
  POST_PURCHASE: 'insurance-post-purchase',
  EXPIRED: 'insurance-post-purchase-expired',
  SUBSCRIBED: 'insurance-post-purchase-subscribed',
}
